<template>
  <div class="lebot-balao" :class="{'is-me': m.sender == sender}" :data-id="m.id_mensagem">
    <div class="lebot-balao-body" v-if="text" v-html="text"></div>
    <div class="balao-hora">
      <i class="balao-status small fa mr-1" :class='{"fa-clock": !m.id_mensagem}' v-if="m.sender == sender"></i>
      <span v-if="m.send_at">{{ m.send_at }}</span>
      <span v-else>{{ m.created_at | hour }}</span>
    </div>
  </div>  
</template>

<script>
export default {
  name: "LebotBalao",
  props: ['m', 'sender'],
  data() {
    return {
      text: null,
      load: false
    }
  },
  methods: {
    formatWppMarkdown(textRef) {
      if (textRef.current !== null) {
        let format = textRef;
        format = this.whatsappStyles(format, "_", "<i>", "</i>");
        format = this.whatsappStyles(format, "*", "<b>", "</b>");
        format = this.whatsappStyles(format, "~", "<s>", "</s>");

        if (format !== undefined) {
          // format = format.replace(/\n/gi, "<br>");
        }

        return this.whatsappLinkStyle(format);
      }
    },

    is_aplhanumeric(c) {
      let x = c.charCodeAt(0);
      return ((x >= 65 && x <= 90) || (x >= 97 && x <= 122) || (x >= 48 && x <= 57));
    },

    whatsappStyles(format, wildcard, opTag, clTag) {
      let indices = [];

      if (format !== undefined) {
        for (let i = 0; i < format.length; i++) {
          if (format[i] === wildcard) {
            if (indices.length % 2)
              (format[i - 1] === " ") ? null : ((typeof (format[i + 1]) == "undefined") ? indices.push(i) : (this.is_aplhanumeric(format[i + 1]) ? null : indices.push(i)));
            else
              (typeof (format[i + 1]) == "undefined") ? null : ((format[i + 1] === " ") ? null : (typeof (format[i - 1]) == "undefined") ? indices.push(i) : ((this.is_aplhanumeric(format[i - 1])) ? null : indices.push(i)));
          } else {
            (format[i].charCodeAt() === 10 && indices.length % 2) ? indices.pop() : null;
          }
        }
      }

      (indices.length % 2) ? indices.pop() : null;

      let e = 0;
      indices.forEach(function (v, i) {
        let t = (i % 2) ? clTag : opTag;
        v += e;
        format = format.substr(0, v) + t + format.substr(v + 1);
        e += (t.length - 1);
      });
      return format;
    },

    whatsappLinkStyle(text) {
      const urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
      const pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      const emailAddressPattern = /[\w.]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,6})+/gim;

      return text
          .replace(urlPattern, '<a href="$&" target="_blank" rel="noreferrer">$&</a>')
          .replace(pseudoUrlPattern, '$1<a href="http://$2" target="_blank" rel="noreferrer">$2</a>')
          .replace(emailAddressPattern, '<a href="mailto:$&" target="_blank" rel="noreferrer">$&</a>');
    },

    iniciar(m) {
      this.text = this.formatWppMarkdown(m.mensagem);
    }
  },

  mounted() {
    this.iniciar(this.m);
  },

  filters: {
    status(value) {
      switch (value) {
        case 'sent':
          return 'fa-check';
        case 'read':
          return 'fa-check read';
        case 'failed':
          return 'fa-exclamation-triangle failed';
        default:
          return 'fa-clock'
      }
    }
  },

  watch: {
    m(val) {
      this.iniciar(val);
    }
  }
}
</script>
<style scoped>
.lebot-balao {
  background-color: #ffffff;
  display: inline-block;
  padding: 6px 7px 8px 9px;
  font-size: 14px;
  border-radius: 6px;
  box-shadow: 0 1px 1px rgba(0,0,0,.13);
  max-width: 80%;
  min-width: 120px;
  text-align: left;
  position: relative;
}

.lebot-balao.is-me {
  background-color: #D9FDD3;
  margin-left: auto;
}

.lebot-balao-body {
  display: inline-block;
  width: 100%;
  position: relative;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.balao-hora {
  margin: 5px 2px -3px;
  text-align: right;
  font-size: 12px;
  opacity: 0.7;
}

.icon {
  margin-right: 2px;
  display: inline-block;
}

.icon i {
  font-size: 22px;
}

.read {
  color: #53bdeb!important;
}

.failed {
  color: var(--warning);
}

.lebot-balao-img {
  width: 200px;
  height: 200px;
  object-fit: cover;
  max-width: 100%;
  border-radius: 4px;
}
</style>